import { ApiResponseModel } from "../shared/models/ApiResponse.model";
import { ErrorMessageEnumApi } from "../shared/enums/error-message.enum";

const errorResponseHandler = (res: ApiResponseModel, setError: any, setIsLoading: any, setSectionNumber: any, type?: string) => {
    const code = res.code;

    switch (code) {
        case "SMS_CANNOT_BE_SENT":
            setError("root.serverError", {
                type: "general",
                message: ErrorMessageEnumApi.SMS_CANNOT_BE_SENT,
            });
            setSectionNumber(3);
            setIsLoading(false);
            return ErrorMessageEnumApi.SMS_CANNOT_BE_SENT;
        case "EMAIL_CANNOT_BE_SENT":
            setError("root.serverError", {
                type: "general",
                message: ErrorMessageEnumApi.EMAIL_CANNOT_BE_SENT,
            });
            setSectionNumber(1);
            setIsLoading(false);
            return ErrorMessageEnumApi.EMAIL_CANNOT_BE_SENT;
        case "resetpwd-002":
            setError("root.serverError", {
                type: "general",
                message: ErrorMessageEnumApi.RESET_PWD_002,
            });
            setSectionNumber(1);
            setIsLoading(false);
            return ErrorMessageEnumApi.RESET_PWD_002;
        case "EXPIRED":
            setError("root.serverError", {
                type: "general",
                message: ErrorMessageEnumApi.EXPIRED,
            });
            setSectionNumber(1);
            setIsLoading(false);
            return ErrorMessageEnumApi.EXPIRED;
        case "NOT_FOUND":
            setError("pin", {
                type: "NOT_FOUND",
                message: ErrorMessageEnumApi.NOT_FOUND,
            });
            setError("root.serverError", {
                type: "general",
                message: ErrorMessageEnumApi.NOT_FOUND,
            });
            setIsLoading(false);
            return ErrorMessageEnumApi.NOT_FOUND;
        case "resetpwd-005":
            setError("email", {
                type: "resetpwd-005",
                message: ErrorMessageEnumApi.RESET_PWD_005,
            });
            setError("root.serverError", {
                type: "general",
                message: ErrorMessageEnumApi.RESET_PWD_005,
            });
            setIsLoading(false);
            return ErrorMessageEnumApi.RESET_PWD_005;
        case "resetpwd-006":
            setError("root.serverError", {
                type: "general",
                message: ErrorMessageEnumApi.RESET_PWD_006,
            });
            setIsLoading(false);
            setSectionNumber(1);
            return ErrorMessageEnumApi.RESET_PWD_006;
        case "INTERNAL_SERVER_ERROR":
            return setError("root.serverError", {
                type: "general",
                message: ErrorMessageEnumApi.INTERNAL_SERVER_ERROR,
            });
        case "ratelimit-001":
            setIsLoading(false);
            switch (type) {
                case "email-send":
                    setSectionNumber(1);
                    break;
                case "sms-send":
                    setSectionNumber(3);
                    break;
            }
            return setError('root.serverError', {
                type: 'general',
                message: ErrorMessageEnumApi.RATELIMIT_001,
            });
    }
};

export {
    errorResponseHandler
}
